import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import HomeSection from './components/HomeSection';
import CasinoU888Section from './components/category/CasinoU888Section';
import SportsU888Section from './components/category/SportsU888Section';
import CockfightingU888Section from './components/category/CockfightingU888Section';
import LotteryU888Section from './components/category/LotteryU888Section';
import AboutU888Section from './components/category/AboutU888Section';
import PromotionU888Section from './components/category/PromotionU888Section';
import { HelmetProvider } from 'react-helmet-async';

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <div className="font-sans bg-dark_gray antialiased">
        <Router>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomeSection />} />
            <Route path="/casino" element={<CasinoU888Section />} />
            <Route path="/promotion" element={<PromotionU888Section />} />
            <Route path="/sports" element={<SportsU888Section />} />
            <Route path="/cockfighting" element={<CockfightingU888Section />} />
            <Route path="/lottery" element={<LotteryU888Section />} />
            <Route path="/about" element={<AboutU888Section />} />
          </Routes>
          <Footer />
        </Router>
      </div>
    </HelmetProvider>
  );
};

export default App; 